export default __webpack_public_path__ + "static/media/ct-01.f7c634aa.jpg";